export const canvas = document.getElementById("canvas");
export const ctx = canvas.getContext("2d");

// Math.rand() * (Math.PI) * 2
const furBomb = new Image();
furBomb.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_150/v1518634990/furbomb_lgaqpu.png';


export default class Bomb {
  constructor() {
    this.bombX = 300;
    this.bombY = 75;
    this.bombWidth = 80;
    this.bombHeight = 80;
    this.bombTheta = (Math.random() * (Math.PI));
    this.xVel = Math.cos(this.bombTheta) * 3;
    this.yVel = Math.sin(this.bombTheta) * 3;
  }


  drawfurBomb() {
    ctx.drawImage(furBomb, this.bombX, this.bombY, this.bombWidth, this.bombHeight);
    if ((this.bombX < canvas.width || this.bombX > canvas.width
    || this.bombY < canvas.height || this.bombY > canvas.height)) {
      this.bombY  += this.yVel;
      this.bombX += this.xVel;
    }
      if (this.bombX < 0) {
      this.xVel *= -1;
    }
    if (this.bombX > canvas.width - this.bombWidth) {
      this.xVel *= -1;
    }
    if (this.bombY < 0) {
      this.yVel *= -1;
    }
    if (this.bombY > canvas.height - this.bombHeight) {
      this.yVel *= -1;
    }
  }
}



// WEBPACK FOOTER //
// ./lib/bomb.js